import { render, staticRenderFns } from "./RedotPay.vue?vue&type=template&id=21f702aa&scoped=true&"
import script from "./RedotPay.vue?vue&type=script&lang=js&"
export * from "./RedotPay.vue?vue&type=script&lang=js&"
import style0 from "./RedotPay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RedotPay.vue?vue&type=style&index=1&id=21f702aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f702aa",
  null
  
)

export default component.exports